export const buildAvatarImageSource = (avatarUrl: Inspire.Image[] | undefined) =>
    avatarUrl?.reduce((prev, curr) => (prev.width > curr.width ? prev : curr), {
        width: 0,
        url: '',
    }).url;
